import React from 'react';
import { Treemap, ResponsiveContainer } from 'recharts';
import { useTranslation } from 'react-i18next';

// Dummy data for the treemap
const data = [
  { name: 'PM', value: 56, color: '#AF69B2' },
  { name: 'HR', value: 16, color: '#C74235' },
  { name: 'Finance', value: 6, color: '#B97BAF' },
  { name: 'Accounting', value: 12, color: '#7CBF97' },
  { name: 'IT', value: 12, color: '#8DA583' },
  { name: 'Marketing', value: 12, color: '#4A80D5' },
  { name: 'Pricing', value: 12, color: '#63B1B6' }
];

const CustomizedContent = (props) => {
  const { t } = useTranslation();
  const { x, y, width, height, color, name, value } = props;
  const displayName = name === 'Others' ? t('generalDashboard.treemapOthers') : name;

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        rx={10} // Rounded corners
        ry={10} // Rounded corners
        style={{
          fill: color,
          stroke: 'white',
          strokeWidth: 2,
          fillOpacity: 1
        }}
        
      />
      {width > 60 && height > 20 ? (
        <text
          x={x + width / 2}
          y={y + height / 2}
          textAnchor="middle"
          fill="#fff"
          fontSize={16}
        >
          {displayName}
        </text>
      ) : null}
      {width > 60 && height > 20 ? (
        <text
          x={x + width / 2}
          y={y + height / 2 + 20}
          textAnchor="middle"
          fill="#fff"
          fontSize={14}
        >
          {`${value}%`}
        </text>
      ) : null}
    </g>
  );
};

const RiskByDepartment = ({ height, risks_by_department }) => {

  //////console.log(risks_by_department);

  return (
    <ResponsiveContainer width="100%" height={height} className="p-2 pb-2">
      <Treemap
        data={risks_by_department}
        dataKey="value"
        stroke="#fff"
        fill="#fff"
                content={<CustomizedContent />}
      />
    </ResponsiveContainer>
  );
};

export default RiskByDepartment;
